module.exports = __webpack_public_path__ + "img/LV40003076407.d484affb.png";